<template>

    <tr class="position_row" :class="{onDelete: isOnDelete}">

        <td>
            <div class="position_name">
                <router-link :to=" 'positions/' + position.id + '/evaluations' " >
                    <span class="position_name">{{ position.name }}</span><br>
                </router-link>

                <div class="associated_recruiter_name" v-if="notOwnedPosition">
                        <span>{{ position.recruiter_name }}</span>

                </div>
            </div>
        </td>

        <td class="">
            <span class="ref_name">{{ getRefName(position.sight_ref) }}</span>
        </td>
        <td class="">

            <div  class="">
                <div class="">
                    <div class="eval_count">
                        <span class='completed_mark is-completed'></span>
                        {{ position.completed_evals_count }} évaluations
                    </div>
                    <div class="eval_count">
                        <span class='completed_mark'></span>
                        {{ position.evals_count - position.completed_evals_count }} évaluations
                    </div>
                </div>
            </div>

        </td>

        <td>{{ createdAt }}</td>
        <td class="">
            <DropDown>
                <template v-slot:dropdownLabel>
                    {{ $t('modules.positions.index.positionsList.actions') }}
                </template>
                <template v-slot:dropdownItems>

                    <router-link :to=" 'positions/' + position.id + '/evaluations' " class="dropdown-item" >
                        {{ $t('modules.positions.index.positionsList.PositionEvalsDetails') }}
                    </router-link>


                    <div v-if="position.evals_count == 0 " class="">
                        <a v-if="canEditPosition" class="dropdown-item"  @click="$emit('openAddEvals', position)">
                            {{ $t('modules.positions.index.positionsList.tableRowAddEvalLink') }}
                        </a>
                        <router-link :to=" 'positions/' + position.id " v-if="canEditPosition" class="dropdown-item" >
                            {{ $t('modules.positions.index.positionsList.editPosition') }}
                        </router-link>
                    </div>
                    <div class="" v-else>
                        <a @click="goCompare(position.id)" class="dropdown-item">
                            {{ $t('modules.positions.index.positionsList.tableRowCompareButton') }}
                        </a>
                        <a class="dropdown-item" @click="$emit('openAddEvals', position)" v-if="canEditPosition">
                            {{ $t('modules.positions.index.positionsList.tableRowAddEvalButton') }}
                        </a>
                        <router-link :to=" 'positions/' + position.id " v-if="canEditPosition" class="dropdown-item" >
                            {{ $t('modules.positions.index.positionsList.editPosition') }}
                        </router-link>
                        <!--<a class="dropdown-item" @click="$emit('openSendReport', position)" v-if="canEditPosition">
                            {{ $t('modules.positions.index.positionsList.tableRowSendReports') }}
                        </a>-->
                    </div>

                </template>
            </DropDown>
        </td>

        <td class="icon_td ">
            <TableDeleteButton @confirmClicked="deletePosition" v-if="!notOwnedPosition" class="is-cursor " />
            <div v-else>-</div>
        </td>
    </tr>


</template>

<script>
import TablePositionsRowEvalsList from './tablePositionsRowEvalsList'

export default {
    name: 'TablePositionsRow',
    props: ['position', 'index'],
    components: {
        TablePositionsRowEvalsList
    },
    data(){
        return {
            openedEvalsLists: [],
            isOnDelete: false,
            userData: JSON.parse(localStorage.getItem('account')).user
        }
    },
    computed: {
        createdAt(){
            return this.$date(this.position.created_at, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).fromNow()
        },
        notOwnedPosition(){
            return this.userData.id != this.position.user_id
        },
        shareModeActive(){
            return JSON.parse(localStorage.getItem('account')).contract.sharing_data_mode == "across_company"
        },
        canEditPosition(){
            return !this.notOwnedPosition || this.shareModeActive
        }
    },
    methods: {
        getRefName(refItem){
            return refItem.job_titles[this.$i18n.locale]
        },
        toggleEvalList(positionId){
            const index = this.openedEvalsLists.indexOf(positionId)
            if (index > -1){
                this.openedEvalsLists.splice(index, 1)
            }else{
                this.openedEvalsLists.push(positionId)
            }
        },
        goCompare(positionId){
            this.$router.push('/positions/compare/' + positionId)
        },
        deleteEvalFromPosition(evaluation){
            const evalIndex = this._.findIndex(this.position.evaluations, function(ev) { return ev.id == evaluation.id });
            if(evalIndex > -1){
                this.$store.dispatch('EvalStore/saveEval', {id: evaluation.id, sight_group_id: null}).then(() => {
                    this.position.evaluations.splice(evalIndex, 1)
                })
            }
        },
        deletePosition(){
            this.isOnDelete = true
            this.$store.dispatch('PositionStore/deletePosition', this.position).then(() => {
                this.$store.dispatch('PositionStore/indexPositions')
                this.$emit('positionDeleted')
            })
        }
    }
}
</script>

<style lang="scss">
#positions_table_container{
    .position_row{
        min-height: $table-row-height;
        height: auto!important;
    }
    .position_name{
        font-weight: 500;
    }
    .positions_actions{
        display: flex;
        .add_candidates_button{
            margin-left: 8px;
        }
    }
    .evals_number{
        margin-left: 36px;
        display: flex;
        cursor: pointer;
        user-select: none;
        svg{
            height: 26px;
            fill: $grey-light;
        }

        &.active{
            .eval_count{
                color: $info;
                background-color: $white;
            }

        }
        &.no_actions{
            cursor: default;
        }
    }
    .add_candidates{
        margin-left: 36px;
        color: $info;
        display: flex;
        align-items: center;
        font-weight: 500;
        cursor: pointer;
        transition: .15s all;
        user-select: none;
        svg{
            height: 22px;
            fill: $info;
            margin-right: 8px;
            transition: .15s all;
        }
        &:hover{
            color: darken($info, 15%);
            svg{
                fill: darken($info, 15%);
            }
        }
    }
    .candidate_name{
        display: flex;
        align-items: center;
        .cand_name{
            display: inline-block;
            padding-left: 28px;
            font-weight: 600;
        }
    }
    .ref_name{
        margin-top: 8px;
        text-transform: uppercase;
        font-weight: 500;
        color: $grey-light;
        font-size: .85rem
    }
    .email_icon{
        text-align: center;
        font-size: 2rem;
        &.is-success{
            color: $success;
        }
        &.is-danger{
            color: $danger;
        }
    }
    .associated_recruiter_name{
        font-style: italic;
        font-weight: 500;
        color: #b5b5b5;
        color: $primary;
    }
}
.position_campaign_link{
    .position_campaign_link_icon{
        cursor: pointer;
    }
    .position_campaign_link_icon:hover{
        color: $info;
    }

}
.position_details_btn{
    svg{
        width: 16px!important;
    }
}
.completed_mark{
    height: 12px;
    width: 12px;
    background-color: #ffdd57;
    display: inline-block;
    border-radius: 100%;
    background-color: $pending-color;
    &.is-completed{
        background-color: $completed-color;
    }
}
.eval_count{

    font-weight: 600;
    font-size: 1.15rem;
    margin: 0 12px 0 6px;
    border: none;
    transition: .3s all;
}
</style>